import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-098da90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content" }
const _hoisted_2 = { class: "flex justify-center copy-feedback" }

import useBrowserSupport from '@/composables/useBrowserSupport'
import { Engine } from '@/types/enums/room.enum'
import { PropType, computed, onMounted } from 'vue'
import BrowserSupportCard from '@/components/checkup/BrowserSupportCard.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BrowserSupportPopup',
  props: {
  roomUrl: {
    type: String,
    default: '',
  },
  engine: {
    type: String as PropType<Engine>,
    default: Engine.TWILIO,
  },
},
  setup(__props) {

const props = __props

const forceChangeBrowser = computed(() => props.engine === Engine.ZOOM)
const { isCopied, isOpen, detectSupportToOpen, copyRoomUrl, close } = useBrowserSupport(
  props.engine,
  props.roomUrl,
)

onMounted(() => {
  detectSupportToOpen()
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Incompatible browser",
    "can-close": !forceChangeBrowser.value,
    open: _unref(isOpen),
    onClose: _unref(close)
  }, {
    footer: _withCtx(() => [
      (!forceChangeBrowser.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-tertiary text-base w-full",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
          }, " Continue at your own risk "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary text-base w-full mt-3 copy-btn", { '-copied': _unref(isCopied) }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(copyRoomUrl) && _unref(copyRoomUrl)(...args)))
      }, [
        _withDirectives(_createElementVNode("span", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            class: "mr-1",
            icon: "success",
            "inherit-fill": true,
            width: "25"
          }),
          _createTextVNode(" Copied ")
        ], 512), [
          [_vShow, _unref(isCopied)]
        ]),
        _withDirectives(_createElementVNode("span", null, "Copy this room link", 512), [
          [_vShow, !_unref(isCopied)]
        ])
      ], 2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(BrowserSupportCard, {
            engine: __props.engine,
            "room-url": __props.roomUrl
          }, null, 8, ["engine", "room-url"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["can-close", "open", "onClose"]))
}
}

})